import Vue from 'vue'

class UploadFilesService {
  upload ({files, commentaire}, onUploadProgress) {

    const formData = new FormData()

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      formData.append('files[]', file)
    }

    formData.append('commentaire', commentaire)

    return Vue.axios.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    })
  }

  getFiles () {
    return Vue.axios.get('/files')
  }

  getFile (id) {
    return Vue.axios.get(`/files/${id}`)
  }

  deleteFile (id) {
    return Vue.axios.delete(`/files/${id}`)
  }
}

export default new UploadFilesService()
